<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-6 offset-md-3 text-center">
                    <img class="customer-logo logo-main img-fluid" v-if="customerLogoIMG" :src="customerLogoIMG">
                    <img v-else src="@/assets/img/logo_recruitment-Accelerator-big.png" class="logo-main img-fluid">
                    <h1> Werf als een <span class="blue-txt">wereldspeler</span></h1>
                </div>

                <div class="col-md-6 offset-md-3 text-center">
                    <div class="wrap-block1">
                      <h4 class="blue-txt" style="font-weight: bold">Wat wil je doen?</h4>

                      <a class="btn btn-primary btn-md mb-3" href="https://www.recruitmentaccelerator.nl"
                         target="_blank"><span
                      >Ik wil meer informatie</span></a>

                      <br>
                      <span class="blue-txt" style="font-weight: bold">of</span><br>


                      <a href="https://dashboard.ravi.works/" class="btn btn-primary btn-md mt-3">Inloggen Dashboard
                      </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  import configs from '../config'
  import {mapGetters} from 'vuex'

  export default {
    name: 'home',
    data () {
      return {
        dashboardUrl: '',
        customerLogoIMG: false
      }
    },
    mounted () {
      this.dashboardUrl = configs.API_URL

      if (typeof this.customerConfigs.logo_url !== 'undefined' && this.customerConfigs.logo_url !== null) {
        this.customerLogoIMG = this.customerConfigs.logo_url
      }
    },
    watch: {
      customerConfigs (customerConfigs) {
        if (typeof customerConfigs.logo_url !== 'undefined' && customerConfigs.logo_url !== null) {
          this.customerLogoIMG = customerConfigs.logo_url;
        }
      }
    },

    computed: mapGetters({
      customerConfigs: 'customer/getConfigs',
    }),
  }
</script>

<style lang="scss">
    .customer-logo {
        max-width: 420px;
        max-height:100px;
    }

    h1, h2 {
        font-weight: normal;
        color: white;
    }

    p {
        color: white;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #35495E;
    }

    .logo-main {
        margin-top: 60px;
        margin-bottom: 70px;
    }

    .underline {
        text-decoration: underline;
        color: #1e3e74;
    }

    .wrap-block2 {
        margin-top: 40px;
    }

    .wrap-block1 {
        padding-top: 45px;
        padding-bottom: 45px;

        h4 {
            margin-top: 0;
            padding-top: 0;
            color: white;
        }
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
